"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.eventMeta = exports.emailLink = void 0;
exports.formEvent = formEvent;
exports.telLink = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
// eslint-disable-next-line no-unused-vars

var telLink = function (number) {
  var {
    label,
    ...attrs
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!number) {
    return undefined;
  }
  return /*#__PURE__*/_react.default.createElement("a", (0, _extends2.default)({
    href: "tel:".concat(number),
    "data-ev-on": "click",
    "data-ev-category": "Tel",
    "data-ev-action": "Call",
    "data-ev-label": number
  }, attrs), label || number);
};
exports.telLink = telLink;
var emailLink = function (email) {
  var {
    label,
    ...attrs
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!email) {
    return undefined;
  }
  return /*#__PURE__*/_react.default.createElement("a", (0, _extends2.default)({
    href: "mailto:".concat(email),
    "data-ev-on": "click",
    "data-ev-category": "Mailto",
    "data-ev-action": "Email",
    "data-ev-label": email
  }, attrs), label || email);
};
exports.emailLink = emailLink;
var eventMeta = _ref => {
  var {
    action,
    category,
    label,
    on = 'click',
    value
  } = _ref;
  if (!(on && category && action)) {
    return {};
  }
  var meta = {
    'data-ev-on': on,
    'data-ev-category': category,
    'data-ev-action': action
  };
  if (label) {
    meta['data-ev-label'] = label;
  }
  if (value) {
    meta['data-ev-value'] = value;
  }
  return meta;
};
exports.eventMeta = eventMeta;
function formEvent(dataLayer, endpoint, type, data, response, label) {
  if (!dataLayer) {
    return;
  }
  dataLayer.push({
    event: 'rwFormSubmit',
    rwFormData: {
      type,
      endpoint,
      data,
      response,
      label
    }
  });
}